"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryPimGridById = void 0;
exports.queryPimGridById = `
  query queryGrid($id: ID!, $language: String) {
    gridById(id: $id, language: $language) {
      id
      name
      createdAt
      items {
        id
        name
        columnIndex
        rowIndex
        layout {
          colspan
          rowspan
        }
        images {
          url
        }
      }
    }
  }
`;
//# sourceMappingURL=grid.js.map